import getColor from "@insite/mobius/utilities/getColor";
import { TYPOGRAPHY } from "@store/theme/design";
import { StoreThemeButtonProps, themeButtonStyles } from "@store/theme/mixins";
import { polyfillCss } from "@store/theme/polyfills";
import { css } from "styled-components";

export const inputLabelStyles = () => {
    return polyfillCss`
        margin-right: 0.5em;
        font-size: ${TYPOGRAPHY.size.small};
        font-weight: ${TYPOGRAPHY.weight.base};
    `;
};

export const inputStyles = () => {
    return css`
        vertical-align: top;
        border-radius: 4px;
        border-color: ${getColor("common.border")};

        &:disabled {
            border-color: ${getColor("common.disabled")};
            background-color: ${getColor(
                "common.disabledLighter",
            )} !important; /* We don't want to exclude dates picker with this selector input:not(.react-datetime-picker__inputGroup__input) */
        }
    `;
};

export const formFieldButtonIconStyles = () => {
    return css`
        &:not(.override) {
            top: 0;
            left: 0;
            background-color: transparent;
            color: inherit;
            transform: scale(1.15);
        }
    `;
};

export const formFieldButtonIconClickableStyles = (themeButtonProps: StoreThemeButtonProps) => {
    return css`
        &:not(.override) {
            ${themeButtonStyles(themeButtonProps)}
            transform: scale(0.85);
        }
    `;
};

export const quantityInputStyles = () => {
    return css`
        width: 45px;
        padding: 0.5em;
        text-align: center;
    `;
};
